define('formkit/behavior/go.to.selected.section.on.event.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');
  

  var GoToSelectedSectionOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // event that will trigger action
      eventName: 'press',

      // object that will emit an event
      eventSource: null,

      // define form
      form: null,

      // the function that determines which section is selected
      selectedSectionGetter: function() {
        return arguments[0].model || this.view.value;
      }
    },

    initialize: function() {
      this.listenTo(this.getOption('eventSource') || this.view, this.getOption('eventName'), this.onEvent)
    },

    onEvent: function() {
      var form = this.getOption('form') || this.view.form;

      var selectedSection = Mn._getValue(this.getOption('selectedSectionGetter'), this, arguments);
      if (form && selectedSection) {
        var selectedSectionIndex = selectedSection.collection.indexOf(selectedSection);
        form.setActiveSectionIndex(selectedSectionIndex);
      }
    }

  });
  module.exports = GoToSelectedSectionOnEventBehavior;
});

